import React from 'react'
import { ZenIcon, ZenText } from "zen-core-elements";
import { DimensionValue, KeyboardTypeOptions, StyleSheet, TextInput, TextInputProps, TouchableOpacity, View } from "react-native";
import { Theme, ThemeConsumer } from "@rneui/themed";
/*
 * Web-only field-box styling and markers. Resolves to an all-empty module
 * on Android (searchFieldWeb.ts), so nothing below changes there.
 */
import { fieldBoxProps, fieldInputProps, webSearchBox, webSearchInnerColumn, webSearchInput, webSearchPlaceholder } from "../../platform/design/searchFieldWeb";

export const CustomSearchBar = ({ search, setSearch, toggleOffset, leftComponent, rightComponent, leftIcon = true, backgroundColor, placeholder, border = false, height, keyboardType, width, inputRef, onFocus, autoCapitalize }: {
	search: string | null;
	setSearch: (text: string | null) => void
	toggleOffset: () => void;
	rightComponent?: React.ReactNode;
	leftComponent?: React.ReactNode;
	leftIcon?: boolean
	backgroundColor?: string
	placeholder: string
	border?: boolean
	height?: number
	keyboardType?: KeyboardTypeOptions | undefined
	width?: DimensionValue
	inputRef?: React.RefObject<TextInput | null>
	onFocus?: () => void
	autoCapitalize?: TextInputProps["autoCapitalize"]
}) => {
	return (
		<ThemeConsumer>
			{({ theme }) => {
				const styles = style(theme)
				return (
					<View style={styles.searchContainer}>
						<View {...fieldBoxProps} style={[styles.searchInputWrapper, backgroundColor && { backgroundColor }, border && { borderColor: theme?.coolGray, borderWidth: 1, borderRadius: 15 }, webSearchBox, height ? { height } : {}, width ? { width } : {}]}>
							{leftComponent}
							{leftIcon && <ZenIcon
								type={"material"}
								name={"search"}
								size={19}
								color={theme.grey}
							/>}
							<View style={[{ flex: 1, top: -5 }, webSearchInnerColumn]}>
								{/* The Actual Input */}
								<TextInput
									ref={inputRef}
									value={search ?? ""}
									onChangeText={setSearch}
									keyboardType={keyboardType}
									onFocus={onFocus}
									style={[styles.searchInput, webSearchInput]}
									autoCapitalize={autoCapitalize}
									{...fieldInputProps}
								// remove the placeholder prop from here
								/>

								{/* The "Fake" Placeholder - Only shows when text is empty */}
								{(!search || search.length === 0) && (
									<View style={[styles.placeholderOverlay, webSearchPlaceholder]} pointerEvents="none">
										<ZenText
											content={placeholder || "Search"}
											style={styles.placeholderText}
										/>
									</View>
								)}
							</View>
							{search ? (
								<TouchableOpacity
									style={{}}
									onPress={() => {
										setSearch(null);
										toggleOffset()
									}}
								>
									<ZenIcon
										name={"clear"}
										type={"material"}
										size={20}
										color={theme.grey}
									/>
								</TouchableOpacity>
							) : null}
						</View>
						{rightComponent}
					</View>
				)
			}}
		</ThemeConsumer>
	);
};

export const style = (theme: Theme) => StyleSheet.create({
	searchContainer: { flexDirection: "row", alignItems: "center", gap: 10 },
	searchInputWrapper: { backgroundColor: theme?.light, borderRadius: 10, flexDirection: 'row', alignItems: 'center', paddingHorizontal: 12, height: 44, elevation: 1, flexGrow: 1, borderWidth: 0 },
	searchInput: { flex: 1, fontSize: theme?.smallHeaderFontSize, fontFamily: theme?.medium, color: theme?.lightDark, top: 3 },

	placeholderOverlay: {
		position: 'absolute',
		left: 5,
		top: 10,
		bottom: 0,
		justifyContent: 'center',
	},

	placeholderText: {
		fontFamily: theme?.medium,
		color: theme?.grey,
		fontSize: theme?.smallHeaderFontSize
	},
});